import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import { Search } from '@material-ui/icons'

export const GreenCheckbox = withStyles({
  root: {
    color: '#43a04754',
    '&$checked': {
      color: '#43a047',
    },
    '&:hover': {
      color: '#43a047',
      backgroundColor: 'initial'
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

export const BlueZoomInIcon = withStyles({
  root: {
    color: 'white',
    background: '#3c57e9',
    fontSize: 18,
    padding: 1,
    borderRadius: '50%'
  }
})(props => <Search {...props} />)

export const useStyles = makeStyles({
  cardItem: {
    position: 'relative',
    padding: 5,
  },
  actionList: {
    display: "flex",
    justifyContent: "flex-start",
    flex:'1 3%'
  },
  rootHiddenDebt: {
    backgroundColor: "lightGray !important",
    opacity: "70%",
  },
  cardItemContent: {
    display: "flex",
    marginTop: "5px",
    justifyContent: "space-between",
    width: '100%',
    borderRadius: 4,
    transition: 'all 0.5s',
    cursor: 'pointer',
    backgroundColor: "#fff",
    position: 'relative',
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0px 8px 14px -5px rgba(0,0,0,0.75)"
    }
  },
  itemCheckbox: {
    zIndex: 7,
    transition: 'all 0.5s',
    display: 'none',
  },
  hideCheckbox: {
    display: 'none',
  },
  showCheckbox: {
    display: 'initial',
  },
  itemZoomIn: {
    zIndex: 7,
    padding: 9,
    transition: 'all 0.5s',
    display: 'none',
  },
  hideZoomIn: {
    display: 'none',
  },
  showZoomIn: {
    display: 'initial',
    marginTop: "3px"
  },
  zoomIn:{
    display: "flex",
    justifyContent: "flex-end",
    flex: "1 3%"
  },

  cardSelected: {
    backgroundColor: "#d2e7f7"
  },

  listStatusDebtLate: {
    borderBottom: '2px solid #d82929',
  },
  cardStatusDebtPayable: {
    borderBottom: '2px solid #7bb94e',
  }
})
